import SkinModel from './skin-model.vue'

export default SkinModel
